import React from 'react';
import { RouteObject, Navigate } from "react-router-dom";
import FormDemo from "../pages/FormDemo";
import TraeGuide from "../pages/TraeGuide";

const PublicRoutes: RouteObject = {
  children: [
    {
      path: "/",
      element: <Navigate to="/rfsic/check/FS251?id=1000000203" replace />,
    },
    {
      path: "form",
      element: <FormDemo />,
    },
    {
      path: "trae-guide",
      element: <TraeGuide />,
    }
  ]
};

export default PublicRoutes;
